/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable max-statements */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { forwardRef, useEffect, useState } from 'react';
import {
	DndContext,
	closestCenter,
	MouseSensor,
	TouchSensor,
	DragOverlay,
	useSensor,
	useSensors
} from '@dnd-kit/core';
import {
	arrayMove,
	SortableContext,
	rectSortingStrategy,
	useSortable
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import LazyImage from '../../../Utils/Components/lazyImageComponent';
import axiosInstance from '../../../../config/axiosInstance';
import { globalEnv } from '../../../../config/baseConfig';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
	QueryClient,
	QueryClientProvider,
	useMutation,
	useQuery
} from 'react-query';
import {
	setSelectedSection,
	setTab
} from '../../../../redux/actions/sideBarAction';
import { hideSearchbarAction } from '../../../../redux/actions/searchBarAction';
import Scrollbars from 'react-custom-scrollbars-2';
import LoadingAnimComponent from '../../../Utils/LoadingAnimations/loadingAnimation';
import { DataNotFoundAnimation } from '../../../Utils/ErrorAnimations/dataNotFoundAnim';
import SaveButton from '../../../Utils/saveButton';
import { SetNotificationAction } from '../../../../redux/actions/notificationAction';
import { stateNotificationsEnum } from '../../../Utils/notification';
import { useTypedSelector } from '../../../../hooks/useTypeSelector';
import { SetUnsavedChangesAction } from '../../../../redux/actions/globalAction';
import placeholder from '../../../../assets/images/placeholder.png';

export function EditImagesOrder() {
	const queryClient = new QueryClient();
	return (
		<QueryClientProvider client={queryClient}>
			<EditImagesOrderDetails />
		</QueryClientProvider>
	);
}

const EditImagesOrderDetails = () => {
	const [activeId, setActiveId] = useState(null);
	const sensors = useSensors(useSensor(MouseSensor), useSensor(TouchSensor));

	async function fetchTopicDetails(id: string) {
		const { data } = await axiosInstance().get(
			`${globalEnv.BASE_URL}/topic/${id}/get-images`
		);
		return data;
	}

	const [images, setImages] = useState<any[]>([]);
	const [imagesClone, setImagesClone] = useState<any[]>([]);
	const [updatedImages, setUpdatedImages] = useState<any[]>([]);

	const [isChanged, setIsChanged] = useState(false);
	const [isSaving, setIsSaving] = useState(false);

	const { topicId } = useParams();

	const [dimensions, setDimensions] = useState({
		width: window.innerWidth,
		height: window.innerHeight
	});
	useEffect(() => {
		function handleResize() {
			setDimensions({
				width: window.innerWidth,
				height: window.innerHeight
			});
		}
		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(
			SetUnsavedChangesAction({
				unsavedChanges: isChanged
			})
		);
	}, [isChanged]);

	dispatch(setSelectedSection('Reorder topic images'));
	dispatch(setTab('documents'));
	dispatch(hideSearchbarAction());

	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);
	const navigate = useNavigate();

	const { data, isFetching, isLoading, isError } = useQuery(
		['images', topicId],
		() => fetchTopicDetails(topicId!),
		{
			keepPreviousData: true,
			refetchOnWindowFocus: false,
			staleTime: 5000,
			cacheTime: 5000
		}
	);

	useEffect(() => {
		const imagesCopy = images.slice();
		imagesCopy.forEach((image, index) => {
			if (image.index !== index) {
				console.log('old idnex', image.index, 'new index', index);
				imagesCopy[index] = { ...image, newIndex: index };
			}
		});
		setImagesClone(imagesCopy);
	}, [activeId]);

	useEffect(() => {
		const updatedImages = imagesClone.filter((image) => {
			if (image.newIndex != null)
				if (image.index !== image.newIndex) return image;
		});

		// Invert updatedImages indices
		const invertedImages: any[] = [];
		updatedImages.forEach((image) => {
			const oldIndex = imagesClone.length - 1 - image.index;
			const newIndex = imagesClone.length - 1 - image.newIndex;
			invertedImages.push({ ...image, index: oldIndex, newIndex: newIndex });
		});

		if (updatedImages.length > 0) setIsChanged(true);
		else setIsChanged(false);
		setUpdatedImages(invertedImages);
	}, [imagesClone]);

	useEffect(() => {
		if (data != null) {
			const images: any[] = [];
			data.forEach((image: any, index: number) => {
				if (data.index == null) image = { ...image, index: index };
				images.push(image);
			});
			setImages(images);
		}
	}, [data]);

	const saveTopicReq = async () => {
		const dto = {
			images: updatedImages
		};

		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};
		const { data: response } = await axiosInstance().put(
			globalEnv.BASE_URL + `/editor/topic/${topicId}/reorder-images`,
			dto,
			config
		);
		return response;
	};

	const saveTopic = useMutation(saveTopicReq, {
		onMutate: () => setIsSaving(true),
		onSuccess: () => {
			setIsSaving(false);
			setIsChanged(false);
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.SUCCESS,
					message: 'Successfully updated topic info.'
				})
			);
		},
		onError: () => {
			setIsSaving(false);
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.ERROR,
					message: "Couldn't update topic info."
				})
			);
		}
	});

	return (
		<Scrollbars autoHide>
			{isLoading ? (
				<LoadingAnimComponent />
			) : isError ? (
				<div className="h-full ml-16 ">
					<div className="flex flex-col mx-auto my-auto text-center align-middle overflow-clip h-full ">
						<div className="mx-auto my-auto self-center">
							<div className="min-h-16">
								<DataNotFoundAnimation height={dimensions.height / 1.5} />
							</div>
							<h3 className="lg:text-2xl text-xl font-bold dark:text-gray-200 text-gray-700 -mt-8">
								{"Couldn't find the data you're looking for!"}
							</h3>
						</div>
					</div>
				</div>
			) : (
				<div className="relative mt-16 ml-16">
					<div className="fixed w-full pb-2 pr-24 flex flex-row z-30 bg-gray-200 dark:bg-gray-800 justify-end">
						<div>
							<button
								className="btn btn-outline btn-sm mr-1 mt-2"
								type="button"
								style={{ transition: 'all .15s ease' }}
								onClick={() => navigate('../documents')}
							>
								Cancel
							</button>
							{isChanged && (
								<SaveButton
									isSaving={isSaving}
									saveFunc={() => saveTopic.mutate()}
								/>
							)}
						</div>
					</div>

					<div className="pt-6">
						<DndContext
							sensors={sensors}
							collisionDetection={closestCenter}
							onDragStart={handleDragStart}
							onDragEnd={handleDragEnd}
							onDragCancel={handleDragCancel}
						>
							<SortableContext items={images} strategy={rectSortingStrategy}>
								<Grid columns={4}>
									{images.map((image: any, index: number) => (
										<SortablePhoto
											key={image._id}
											image={image}
											index={index}
										/>
									))}
								</Grid>
							</SortableContext>

							<DragOverlay adjustScale={true}>
								{activeId ? (
									<Photo image={activeId} index={images.indexOf(activeId)} />
								) : null}
							</DragOverlay>
						</DndContext>
					</div>
				</div>
			)}
		</Scrollbars>
	);

	function handleDragStart(event: any) {
		setActiveId(event.active.id);
	}

	function handleDragEnd(event: any) {
		const { active, over } = event;
		if (active.id !== over.id) {
			setImages((items: any[]) => {
				const oldIndex = items.indexOf(active.id);
				const newIndex = items.indexOf(over.id);

				return arrayMove(items, oldIndex, newIndex);
			});
		}

		setActiveId(null);
	}

	function handleDragCancel() {
		setActiveId(null);
	}
};

function Grid({ children, columns }: { children: any[]; columns: number }) {
	return (
		<div
			style={{
				display: 'grid',
				gridTemplateColumns: `repeat(${columns}, 1fr)`,
				gridGap: 10,
				padding: 10
			}}
		>
			{children}
		</div>
	);
}

const SortablePhoto = (props: any) => {
	const sortable = useSortable({ id: props.image });
	const {
		attributes,
		listeners,
		isDragging,
		setNodeRef,
		transform,
		transition
	} = sortable;

	const style = {
		transform: CSS.Transform.toString(transform),
		transition
	};

	return (
		<Photo
			ref={setNodeRef}
			style={style}
			isDragging={isDragging}
			{...props}
			{...attributes}
			{...listeners}
		/>
	);
};

const Photo = forwardRef(
	(
		{
			image,
			style,
			isDragging,
			...props
		}: {
			image: any;
			index: number;
			isDragging?: boolean;
			faded?: any;
			style?: any;
		},
		ref: any
	) => {
		const inlineStyles = {
			transformOrigin: '0 0',
			gridRowStart: null,
			gridColumnStart: null,
			opacity: isDragging ? 0 : 1,
			...style
		};

		const [random] = useState(Math.floor(Math.random() * 101));
		return (
			<div
				ref={ref}
				style={inlineStyles}
				{...props}
				className="flex flex-wrap flex-col w-full p-4 cursor-pointer"
			>
				<div className="relative rounded-lg flex justify-center content-center w-full aspect-[16/10] dark:bg-gray-600 bg-gray-300 mb-2 group">
					<LazyImage
						photo={image.url_low_res != null ? image.url_low_res : placeholder}
						style={
							'block object-cover object-center w-full aspect-[16/10] rounded-lg'
						}
						loaderDimesnions={80}
					/>
				</div>
				<h3 className="mx-auto text-gray-700 dark:text-gray-200 font-semibold">
					{image.title}
				</h3>
			</div>
		);
	}
);

export default EditImagesOrder;
